module.exports = __webpack_public_path__ + "img/img_7.891769ef.jpg";